var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAgendamentos({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.8333 3.16665H15V1.58331H13.3333V3.16665H6.66667V1.58331H5V3.16665H4.16667C3.24167 3.16665 2.50833 3.87915 2.50833 4.74998L2.5 15.8333C2.5 16.7042 3.24167 17.4167 4.16667 17.4167H15.8333C16.75 17.4167 17.5 16.7042 17.5 15.8333V4.74998C17.5 3.87915 16.75 3.16665 15.8333 3.16665ZM15.8333 15.8333H4.16667V7.91665H15.8333V15.8333ZM15.8333 6.33331H4.16667V4.74998H15.8333V6.33331ZM10 10.2917H14.1667V14.25H10V10.2917Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAgendamentos);
export default __webpack_public_path__ + "static/media/Agendamentos.94174e4989584cbd79d4e88eb60c3b92.svg";
export { ForwardRef as ReactComponent };